module.exports = require("core-js-pure/stable/instance/sort");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/sort.js
// module id = 598
// module chunks = 0 1